import {IconButton} from "@material-ui/core";
import React from "react";
import {Link} from "react-router";
import LinkIcon from "material-ui/svg-icons/content/link";

export default function renderLink(organisationId, key, context) {
  const href = getHref(organisationId, key, context);
  if (href) {
    return (
      <Link to={href}>
        <IconButton size="small" style={{padding: 0}}>
          <LinkIcon />
        </IconButton>
      </Link>
    );
  }
}

function getHref(organisationId, key, context) {
  if (key === "project_id") {
    return `/organisation/${organisationId}/project/${context.project_id}/document/list`;
  }
  if (key === "document_id") {
    return `/organisation/${organisationId}/project/${context.project_id}/document/${context.document_id}/detail`;
  }
  if (key === "issue_id") {
    return `/organisation/${organisationId}/issue/${context.issue_id}?open_issue_list=true&project=${context.project_id}&document=${context.document_id}`;
  }
  if (key === "parent_run_id") {
    return `/organisation/${organisationId}/llm_run/${context.parent_run_id}/detail`;
  }
  return null;
}
